import APIConnector from "../lib/APIConnector";
import Settings from "../base/Settings";
const apiConnector = new APIConnector({ timeout: 30000 });
const apiConnectorLarge = new APIConnector({ timeout: 120000 });

export default class UserConfig {
  static get endpoint() {
    return Settings.SERVICE_DOMAIN;
  }
  static get endpoint2() {
    return Settings.SERVICE_DOMAIN_V2;
  }
  static get endpointUsers() {
    return `${UserConfig.endpoint}/users`;
  }
  static get endpointLoyaly() {
    return `${UserConfig.endpoint}/loyaly`;
  }
  static get transferPointEndpoint() {
    return `${UserConfig.endpointLoyaly}/recharge-points`;
  }
  static get endpointUsersByReg() {
    return `${UserConfig.endpointUsers}/reg`;
  }
  static get endpointUsersByEmailOrDU() {
    return `${UserConfig.endpointUsers}/usersByEmailOrDU`;
  }
  static get endpointUserById() {
    return `${UserConfig.endpointUsers}/userById`;
  }
  static get endpointUsersFromStorage() {
    return `${UserConfig.endpoint2}/users/usersFromStorage`;
  }
  static get endpointSaveUser() {
    return `${UserConfig.endpointUsers}/save`;
  }
  static get endpointDeleteUser() {
    return `${UserConfig.endpointUsers}/delete`;
  }
  static get endpointAddTagToUser() {
    return `${UserConfig.endpointUsers}/add-tags`;
  }
  static get endpointSendNotification() {
    return `${UserConfig.endpointUsers}/sendNotification`;
  }

  static get endpointMovementsLoyalty() {
    return `${UserConfig.endpoint}/loyaly/user`;
  }
  static get APIConnector() {
    return apiConnector;
  }
  static get APIConnectorLarge() {
    return apiConnectorLarge;
  }
}



// WEBPACK FOOTER //
// ./src/provider/user/UserConfig.js